// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_coursesPagination__etb-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.styles_chevronIcon__gUFH7 {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}
.styles_chevronIcon--left__37smO {
  transform: rotate(90deg);
}
.styles_chevronIcon--right__NHJbv {
  transform: rotate(-90deg);
}

.styles_paginationNav__u2dkS {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-strokes);
  font-weight: 500;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
  min-width: 40px;
  justify-content: center;
}
@media (min-width: 768px) {
  .styles_paginationNav__u2dkS {
    padding: 12px 16px;
    min-width: 100px;
  }
}
.styles_paginationNav__u2dkS span {
  display: none;
}
@media (min-width: 768px) {
  .styles_paginationNav__u2dkS span {
    display: inline;
    font-size: 16px;
    line-height: 100%;
    color: var(--color-black);
  }
}
.styles_paginationNav__u2dkS:hover:not(:disabled) {
  background-color: var(--color-bg-light-blue);
  border-color: var(--color-blue-light);
}
.styles_paginationNav__u2dkS:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

.styles_paginationNumbers__SguFM {
  display: flex;
  align-items: center;
}
@media (min-width: 768px) {
  .styles_paginationNumbers__SguFM {
    gap: 12px;
  }
}

.styles_paginationNumber__5brI3 {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: transparent;
  font: var(--typography-body-m-medium);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_paginationNumber__5brI3:hover {
  background-color: var(--color-bg-light-blue);
  color: var(--color-black);
}
.styles_paginationNumber--active__f3D4x {
  background-color: var(--color-bg-light-blue);
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/components/pagination/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAAF;AAEE;EACE,wBAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,uBAAA;AAFF;ACzBE;EDeF;IAeI,kBAAA;IACA,gBAAA;EADF;AACF;AAGE;EACE,aAAA;AADJ;AClCE;EDkCA;IAII,eAAA;IACA,eAAA;IACA,iBAAA;IACA,yBAAA;EAAJ;AACF;AAGE;EACE,4CAAA;EACA,qCAAA;AADJ;AAIE;EACE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;ACzDE;ED0DF;IAKI,SAAA;EAFF;AACF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;EACA,kCAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACE,4CAAA;EACA,yBAAA;AAFJ;AAKE;EACE,4CAAA;EACA,yBAAA;AAHJ","sourcesContent":["@import \"mixins\";\n.coursesPagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.chevronIcon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n\n  &--left {\n    transform: rotate(90deg);\n  }\n\n  &--right {\n    transform: rotate(-90deg);\n  }\n}\n\n.paginationNav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-strokes);\n  font-weight: 500;\n  cursor: pointer;\n  padding: 12px;\n  border-radius: 12px;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  justify-content: center;\n\n  @include md {\n    padding: 12px 16px;\n    min-width: 100px;\n  }\n\n  & span {\n    display: none;\n\n    @include md {\n      display: inline;\n      font-size: 16px;\n      line-height: 100%;\n      color: var(--color-black);\n    }\n  }\n\n  &:hover:not(:disabled) {\n    background-color: var(--color-bg-light-blue);\n    border-color: var(--color-blue-light);\n  }\n\n  &:disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n  }\n}\n\n.paginationNumbers {\n  display: flex;\n  align-items: center;\n\n  @include md {\n    gap: 12px;\n  }\n}\n\n.paginationNumber {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  font: var(--typography-body-m-medium);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background-color: var(--color-bg-light-blue);\n    color: var(--color-black);\n  }\n\n  &--active {\n    background-color: var(--color-bg-light-blue);\n    color: var(--color-black);\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coursesPagination": `styles_coursesPagination__etb-1`,
	"chevronIcon": `styles_chevronIcon__gUFH7`,
	"chevronIcon--left": `styles_chevronIcon--left__37smO`,
	"chevronIcon--right": `styles_chevronIcon--right__NHJbv`,
	"paginationNav": `styles_paginationNav__u2dkS`,
	"paginationNumbers": `styles_paginationNumbers__SguFM`,
	"paginationNumber": `styles_paginationNumber__5brI3`,
	"paginationNumber--active": `styles_paginationNumber--active__f3D4x`
};
export default ___CSS_LOADER_EXPORT___;
